import Axios from 'axios';
import Api from './Api';

const map = new Map();

export default class ApiAjax {
  constructor(parameters = {}) {
    const request = {
      headers: {},
      ...parameters,
    };
    request.url = `${request.host || Api.config.host || ''}${request.url}`;

    if (Api.config.secret) {
      request.headers.ClientSecret = Api.config.secret;
      request.headers.UserName = Api.config.user;
      request.headers.PartnerCode = Api.config.agency;
    }

    if (Api.config.token) {
      request.headers.Authorization = Api.config.token;
    }

    if (request.store) {
      const item = map.get(request.store.key);
      if (item) return item;
    }

    const promise = new Promise((resolve, reject) => {
      Axios(request)
        .then(({ data }) => {
          if (request.store) {
            setTimeout(() => {
              map.delete(request.store.key);
            }, 100);
          }
          if (data?.ResultQueryInfo?.HasError || data?.ResultQueryInfo?.UserMessages) {
            reject({
              type: 'error',
              message: data.ResultQueryInfo.UserMessages,
            });
          } else {
            resolve(data);
          }
        }, (err) => {
          if (Axios.isCancel(err)) {
            return;
          }
          if (err?.response?.status === 401) {
            if (!Api.config.agency || !Api.config.login) {
              window.location.href = Api.config.login_url;
              return;
            }
            import('./ApiAuthentication')
              .then((module) => {
                const auth = module.default.get(Api.config.agency, Api.config.login);
                auth.then(() => {
                  new ApiAjax(request).then(resolve, reject);
                });
              }, () => {
                window.location.href = Api.config.login_url;
              });
          } else {
            reject({
              type: 'error',
              message: `API__ERROR_${err?.response?.status || -1}`,
            });
          }
        });
    });
    if (request.store) {
      map.set(request.store.key, promise);
    }
    return promise;
  }
}
